export const getEndpointUrl = ckey => ({
  Machemetry: "https://api.raventelemetry.com/",
  Askr: ckey ? `https://${ckey}.gke-us-east1.raven-cloud.com/askr` : "",
  Midgard: ckey ? `https://${ckey}.gke-us-east1.raven-cloud.com/midgard` : "", // login landing page
});
